import { BasicButton } from "@certn/cascadia-react";
import { t } from "i18next";

export function HelpCenterButton() {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://help.certn.co/hc/en-us/sections/16169554705427"
      style={{ textDecoration: "none" }} // Cascadia Links have underlines
    >
      <BasicButton testID="help-and-privacy-help-center-button" size="medium">
        {t("Help Center")}
      </BasicButton>
    </a>
  );
}
